import { api } from '../../../shared/api';
import type { User } from '../../auth/types';

export interface ProfileUpdateRequest {
  name?: string;
  avatar?: string;
}

export interface PasswordChangeRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ProfileResponse {
  success: boolean;
  data: {
    user: User;
  };
}

export interface ProfileUpdateResponse {
  success: boolean;
  message: string;
  data: {
    user: User;
  };
}

export interface PasswordChangeResponse {
  success: boolean;
  message: string;
}

export const profileApi = {
  // Get user profile
  getProfile: async (): Promise<User> => {
    const response = await api.get<ProfileResponse>('/profile');
    return response.data.user;
  },

  // Update user profile
  updateProfile: async (profile: ProfileUpdateRequest): Promise<User> => {
    const response = await api.put<ProfileUpdateResponse>('/profile', profile);
    return response.data.user;
  },

  // Change password
  changePassword: async (
    passwordData: PasswordChangeRequest,
  ): Promise<void> => {
    await api.put<PasswordChangeResponse>('/profile/password', passwordData);
  },

  // Upload profile picture
  uploadProfilePicture: async (avatarUrl: string): Promise<User> => {
    const response = await api.post<ProfileUpdateResponse>('/profile/avatar', {
      avatarUrl,
    });
    return response.data.user;
  },

  // Get upload URL for profile picture
  getUploadUrl: async (
    filename: string,
    contentType: string,
  ): Promise<{ signedUrl: string; token: string; path: string }> => {
    const response = await api.post<{
      success: boolean;
      data: {
        signedUrl: string;
        token: string;
        path: string;
      };
    }>('/profile/upload-url', { filename, contentType });
    return response.data;
  },

  // Logout (deprecated; use AuthProvider.logout())
};
